module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "expect-job-detail",
    on: {
      "click": _vm.showPopup
    }
  }, [_c('span', {
    staticClass: "title-tip"
  }, [_vm._v("谁能看到这份简历")]), _vm._v(" "), _c('span', {
    staticClass: "selected-text"
  }, [_vm._v(_vm._s(_vm.selectedText))])]), _vm._v(" "), _c('popup', {
    model: {
      value: (_vm.showBox),
      callback: function($$v) {
        _vm.showBox = $$v
      },
      expression: "showBox"
    }
  }, [_c('div', {
    staticClass: "popup-box"
  }, [_c('div', {
    staticClass: "popup-title"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("选择能看到这份简历的招聘方范围")])]), _vm._v(" "), _c('ul', _vm._l((_vm.selectList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "item",
      class: {
        'selected': index === _vm.selectedIndex
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(index)
        }
      }
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('span', {
      staticClass: "text-tip"
    }, [_vm._v(_vm._s(item.textTip))]), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.selectedIndex),
        expression: "index === selectedIndex"
      }]
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "division"
  }), _vm._v(" "), _c('div', {
    staticClass: "cancel-btn",
    on: {
      "click": _vm.hidePopup
    }
  }, [_vm._v("取消")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08807d1c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/basic/components/expectation/privacySetting/privacyCompany.vue
// module id = 333
// module chunks = 0